import creditAllTiers from './item/all-tier.json'
import creditBronze from './item/bronze.json'
import creditSilver from './item/silver.json'
import creditGold from './item/gold.json'
import creditDiamond from './item/diamond.json'
import creditPlatinum from './item/platinum.json'

import itemAllTiers from './credit/all-tier.json'
import itemBronze from './credit/bronze.json'
import itemSilver from './credit/silver.json'
import itemGold from './credit/gold.json'
import itemDiamond from './credit/diamond.json'
import itemPlatinum from './credit/platinum.json'

export const REWARDS = {
  'a0444b73-e429-44ba-89fd-233843920db1:1': creditAllTiers.data,
  '5f63d4a5-51e1-4d06-8fd4-4fbf8b8180df:1': creditBronze.data,
  'f54a8882-1d80-46ec-b6b3-72b63fcf4c4a:1': creditSilver.data,
  'e804da89-2283-45ce-a590-df7035df8266:1': creditGold.data,
  '3c9d3b36-051e-4554-b817-956d55f29e20:1': creditDiamond.data,
  'dd5d4e13-873f-4aaa-801c-4b4ed339158a:1': creditPlatinum.data,
  'a0444b73-e429-44ba-89fd-233843920db1:2': itemAllTiers.data,
  '5f63d4a5-51e1-4d06-8fd4-4fbf8b8180df:2': itemBronze.data,
  'f54a8882-1d80-46ec-b6b3-72b63fcf4c4a:2': itemSilver.data,
  'e804da89-2283-45ce-a590-df7035df8266:2': itemGold.data,
  '3c9d3b36-051e-4554-b817-956d55f29e20:2': itemDiamond.data,
  'dd5d4e13-873f-4aaa-801c-4b4ed339158a:2': itemPlatinum.data
}
